import React from 'react';

const LoanBank: React.FC<{ height?: string; width?: string; fillColor?: string }> = ({
	height = '30',
	width = '30',
	fillColor = '#009CDE',
}) => {
	return (
		<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect width={width} height={height} rx="15" fill={fillColor} />
			<path
				d="M14.0829 7.291C14.3493 7.1019 14.6705 7 15.0003 7C15.33 7 15.6513 7.1019 15.9176 7.291L22.514 11.9722C23.3825 12.5875 22.9354 13.9229 21.8616 13.9255H8.13805C7.06427 13.9229 6.61805 12.5875 7.4856 11.9722L14.082 7.291H14.0829ZM15.8892 10.6835C15.8892 10.4542 15.7955 10.2344 15.6288 10.0723C15.4621 9.91019 15.236 9.81913 15.0003 9.81913C14.7645 9.81913 14.5384 9.91019 14.3717 10.0723C14.205 10.2344 14.1114 10.4542 14.1114 10.6835C14.1114 10.9127 14.205 11.1325 14.3717 11.2946C14.5384 11.4567 14.7645 11.5478 15.0003 11.5478C15.236 11.5478 15.4621 11.4567 15.6288 11.2946C15.7955 11.1325 15.8892 10.9127 15.8892 10.6835Z"
				fill="white"
			/>
			<path d="M14.3334 19.1107H12.5557V14.7891H14.3334V19.1107Z" fill="white" />
			<path d="M17.4448 19.1107H15.667V14.7891H17.4448V19.1107Z" fill="white" />
			<path d="M20.7773 19.1107H18.7773V14.7891H20.7773V19.1107Z" fill="white" />
			<path
				d="M21 19.9746H9C8.46957 19.9746 7.96086 20.1795 7.58579 20.5442C7.21071 20.9089 7 21.4036 7 21.9193V22.3515C7 22.7102 7.29867 22.9997 7.66667 22.9997H22.3333C22.5101 22.9997 22.6797 22.9314 22.8047 22.8099C22.9298 22.6883 23 22.5234 23 22.3515V21.9193C23 21.4036 22.7893 20.9089 22.4142 20.5442C22.0391 20.1795 21.5304 19.9746 21 19.9746Z"
				fill="white"
			/>
			<path d="M11.2227 19.1107H9.22266V14.7891H11.2227V19.1107Z" fill="white" />
		</svg>
	);
};

export default LoanBank;
